<template>
  <el-table stripe ref='multipleTable' :data='tableData' tooltip-effect='dark' style='width: 100%' v-loading='loading'
            :header-cell-style='headCellStyle' :height='tableHeight' @selection-change='handleSelectionChange'>
    <el-table-column type='selection' width='55'></el-table-column>
    <el-table-column prop='sceneName' :label="$t('public.table_scope')"
                     show-overflow-tooltip></el-table-column>
    <el-table-column prop='archName' :label="$t('public.table_arch')" show-overflow-tooltip></el-table-column>
    <el-table-column prop='address' :label="$t('noticelog.email')" show-overflow-tooltip></el-table-column>
    <el-table-column prop='content' :label="$t('noticelog.mail_content')" show-overflow-tooltip>
      <template #default='{ row }'>
        {{ row.content.replace(/\\%/g, '%') }}
      </template>
    </el-table-column>
    <el-table-column prop='type' :label="$t('noticelog.type')" show-overflow-tooltip>
      <template #default='{ row }'>
        {{ typeFn(row.type) }}
      </template>
    </el-table-column>
    <el-table-column prop='status' :label="$t('noticelog.send_status')" show-overflow-tooltip>
      <template #default='{ row }'>
        {{ statusFn(row.status) }}
      </template>
    </el-table-column>
    <el-table-column prop='sendTime' :label="$t('noticelog.send_time')" show-overflow-tooltip>
      <template #default='{ row }'>
        {{ $timetransition(row.sendTime) }}
      </template>
    </el-table-column>
    <el-table-column :label="$t('public.table_operation')" width='100'>
      <template #default='{ row }'>
        <div class='uk-flex uk-flex-center'>
          <el-button @click='details(row)' type='text' size='small' :title="$t('public.btn_view')"
                     icon='el-icon-tickets' v-has="['viewEmailNoticeLog']"></el-button>
          <el-button type='text' size='small' @click='handledelete(row)' :title="$t('public.btn_delete')"
                     v-has="['delEmail']" icon='el-icon-delete'></el-button>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { getIsSys } from '@/utils/permission'

export default {
  props: ['tableData', 'loading'],
  computed: {
    isSys () {
      return getIsSys()
    }
  },
  data () {
    return {
      tableHeight: 'calc(100% - 60px)'
    }
  },
  methods: {
    handleSelectionChange (row) {
      this.$emit('choozeTable', row)
    },
    details (row) {
      this.$emit('details', row)
    },
    handledelete (row) {
      this.$emit('handledelete', row)
    },
    statusFn (status) {
      return status === 1 ? this.$t('noticelog.send_success') : this.$t('noticelog.send_fail')
    },
    typeFn (status) {
      // return status === 1 ? this.$t('type_alarm') : this.$t('type_captcha');
      switch (status) {
        case 1:
          return this.$t('noticelog.type_alarm')
      }
    }
  }
}
</script>

<style></style>
